import React, { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { CanView } from 'src/components/CanView';
import { SelectReportee } from './SelectReportee';
import { useSelector } from 'react-redux';
import { getUserRoles } from 'src/redux/features/users/usersSlice';
import ResourceSearchableDropdown from 'src/components/ResourceSearch';
import en from 'src/messages/en.json';
const ResourceFilterHoc = ({ teamTime, onUserChange }) => {
  const auth = useAuth();
  const userRoles = useSelector(getUserRoles);
  const [selectedReportee, setSelectedReportee] = useState<any>();
  const [selectedProjectReportee, setSelectedProjectReportee] =
    useState<string>();
  const reportees = (auth?.user?.profile?.reportee as string) || '[]';

  const [parsedReportees, setParsedReportees] = useState();

  const onSelectedReporteeChange = (selected) => {
    if (selected && selected[0]) {
      onUserChange(selected);

      setSelectedReportee(selected);
    } else {
      setSelectedReportee(null);
      onUserChange(null);
    }
  };

  const onSelectedResourceChange = (selected) => {
    if (selected) {
      setSelectedReportee({ name: selected.label, email: selected.value });
      onUserChange(selected.value);
    } else {
      setSelectedReportee(null);
      onUserChange(null);
    }
  };

  const onSelectedProjectResourceChange = (selected) => {
    if (selected && selected[0]) {
      setSelectedProjectReportee(selected[0].email);
      onUserChange(selected[0].email);
    }

    if (selected.length === 0) {
      setSelectedProjectReportee(null);
      onUserChange(null);
    }
  };

  useEffect(() => {
    setParsedReportees(JSON.parse(reportees));
  }, [reportees]);

  if (!teamTime) {
    return null;
  }

  return (
    <>
      <CanView userRole={userRoles.data} allowedRoles={['CapexAdmin']}>
        <ResourceSearchableDropdown
          selected={
            selectedReportee
              ? { label: selectedReportee.name, value: selectedReportee.email }
              : null
          }
          onChange={onSelectedResourceChange}
          style={{ width: '18rem' }}
          placeholder={en.Common.Placeholder.selectResource}
          internalResourceFlag={true}
        />
      </CanView>
      <CanView userRole={userRoles.data} allowedRoles={['CapexAdManager']}>
        <SelectReportee
          data={parsedReportees}
          onItemChange={onSelectedReporteeChange}
        />
      </CanView>
    </>
  );
};

export default ResourceFilterHoc;
